// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__3-t_e","dark":"Loading_dark__HxRb3","light":"Loading_light__nfPIn","spinner":"Loading_spinner__3N8VB","spin":"Loading_spin__3VhC0"};